import "core-js/modules/es.array.map.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["textContent"];
import { get, remove } from '@/api/system/mail';
import { useCommonDialog } from '@/component-create/utils/hooks';
import { MAIL_TYPE } from '@/constant/system/code';
import { isOnlyOne } from '@/utils/common';
import { deleteBox, toast } from '@/utils/message';
import { renderMailAdd } from './add';
import { renderMailEdit } from './edit';
import { renderMailSearchForm } from './search';
import { createTable } from './table';
import Contact from './Contact.vue';
import { renderSendForm } from './send';

import { ref, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Mail',
  setup: function setup(__props) {
    var searchRef = ref();
    var tableRef = ref();
    var mailAddFormRef = ref();
    var mailEditFormRef = ref();
    var mailSendFormRef = ref();
    var contactRef = ref();
    var searchData = {};
    var table;
    var mail = ref({
      mailSubject: '',
      mailContent: '',
      mailType: ''
    });
    var mailAddForm;
    var mailEditForm;
    var mailSendForm;
    var mailContentDialog = useCommonDialog('showMailContent');
    onMounted(function () {
      table = createTable(tableRef.value, {
        rowDelete: rowDelete,
        rowEdit: rowEdit,
        rowSend: rowSend,
        rowShow: rowShow
      }, {
        addFn: addFn,
        deleteFn: deleteFn,
        editFn: editFn,
        contactsFn: contactsFn
      });
      var search = renderMailSearchForm(searchRef.value);
      search.onSearch = function (formData) {
        searchData = formData;
        table.load(searchData);
      };
      search.onReset = function () {
        searchData = {};
        table.load(searchData);
      };
      mailAddForm = renderMailAdd(mailAddFormRef.value);
      mailAddForm.onSaveSuccess = function () {
        table.load(searchData);
      };
      mailEditForm = renderMailEdit(mailEditFormRef.value);
      mailEditForm.onSaveSuccess = function () {
        table.load(searchData);
      };
      mailSendForm = renderSendForm(mailSendFormRef.value);
    });
    function rowDelete(row) {
      deleteBox().then(function () {
        remove([row.id]).then(function () {
          toast.success('删除成功');
          table.load(searchData);
        });
      });
    }
    function rowEdit(row) {
      mailEditForm.open(row.id);
    }
    function rowSend(row) {
      mailSendForm.open(row.id);
    }
    function rowShow(row) {
      mailContentDialog.open();
      get(row.id).then(function (res) {
        mail.value = res.data;
      });
    }
    function addFn() {
      mailAddForm.open();
    }
    function deleteFn(rows) {
      if (rows.length === 0) {
        toast.warn('请至少选择一条数据');
      } else {
        remove(rows.map(function (i) {
          return i.id;
        })).then(function () {
          toast.success('删除成功');
          table.load(searchData);
        });
      }
    }
    function editFn(row) {
      if (isOnlyOne(row)) {
        mailEditForm.open(row[0].id);
      }
    }
    function contactsFn() {
      var _contactRef$value;
      (_contactRef$value = contactRef.value) === null || _contactRef$value === void 0 || _contactRef$value.open();
    }
    return function (_ctx, _cache) {
      var _component_ElFormItem = _resolveComponent("ElFormItem");
      var _component_ElForm = _resolveComponent("ElForm");
      var _component_XCommonDialog = _resolveComponent("XCommonDialog");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "search",
            ref_key: "searchRef",
            ref: searchRef
          }, null, 512), _createElementVNode("div", {
            class: "table",
            style: {
              "height": "100%"
            },
            ref_key: "tableRef",
            ref: tableRef
          }, null, 512), _createVNode(_component_XCommonDialog, {
            ref: "showMailContent",
            title: "邮件详情"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_ElForm, null, {
                default: _withCtx(function () {
                  return [_createVNode(_component_ElFormItem, {
                    label: "主题"
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(_unref(mail).mailSubject), 1)];
                    }),
                    _: 1
                  }), _createVNode(_component_ElFormItem, {
                    label: "内容"
                  }, {
                    default: _withCtx(function () {
                      return [_unref(mail).mailType === _unref(MAIL_TYPE).HTML.CODE ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        style: {
                          "overflow-y": "auto",
                          "width": "800px"
                        },
                        innerHTML: _unref(mail).mailContent
                      }, null, 8, _hoisted_1)) : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        textContent: _toDisplayString(_unref(mail).mailContent)
                      }, null, 8, _hoisted_2))];
                    }),
                    _: 1
                  })];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 512), _createVNode(Contact, {
            ref_key: "contactRef",
            ref: contactRef
          }, null, 512), _createElementVNode("div", {
            ref_key: "mailAddFormRef",
            ref: mailAddFormRef
          }, null, 512), _createElementVNode("div", {
            ref_key: "mailEditFormRef",
            ref: mailEditFormRef
          }, null, 512), _createElementVNode("div", {
            ref_key: "mailSendFormRef",
            ref: mailSendFormRef
          }, null, 512)];
        }),
        _: 1
      });
    };
  }
});